const stretchRow = {
  display: "flex",
  alignItems: "stretch",
  gap: "10px",
  width: "100%",
};

const stretchCell = {
  display: "flex",
  flexDirection: "column",
  minHeight: "100%",
};

/** Quote Info | Dates + Ports */
export const QuoteInfoDatesPortsSection = ({ wide, quoteInfo, dates, ports }) => {
  if (!wide) {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {quoteInfo}
        {dates}
        {ports}
      </div>
    );
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "10px",
        alignItems: "start",
        width: "100%",
      }}
    >
      <div>{quoteInfo}</div>
      <div style={{ display: "grid", gap: "10px" }}>
        {dates}
        {ports}
      </div>
    </div>
  );
};

/** Equipment | Goods — mesma altura */
export const QuoteEquipmentGoodsSection = ({ wide, equipment, goods }) => {
  if (!wide) {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {equipment}
        {goods}
      </div>
    );
  }

  return (
    <div style={stretchRow}>
      <div style={{ ...stretchCell, width: "320px", flexShrink: 0 }}>{equipment}</div>
      <div style={{ ...stretchCell, flex: 1, minWidth: 0 }}>{goods}</div>
    </div>
  );
};
